"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumerServicesMediaTypes = void 0;
var enums_1 = require("../shared/enums");
/**
 * We need to add all routes with and without params.
 * After React Router v6 they had removed support for optional route param
 * In this comment https://github.com/remix-run/react-router/issues/7285#issuecomment-620071853
 */
exports.consumerServicesMediaTypes = (_a = {},
    _a[enums_1.ServicesEnum.IDENTITY] = {
        'users/:userUUID': 'application/vnd.users.v1+json',
        users: 'application/vnd.users.v1+json',
        launches: 'application/vnd.launches.v1+json',
        'launches/:lauchesUUID': 'application/vnd.launches.v1+json',
        enrollments: 'application/vnd.enrollments.v1+json',
        syncs: 'application/vnd.syncs.v1+json',
    },
    _a[enums_1.ServicesEnum.COMMERCE] = {
        products: 'application/vnd.products.v1+json',
        'products/:productsUUID': 'application/vnd.products.v1+json',
        subscriptions: 'application/vnd.subscriptions.v1+json',
        'subscriptions/:subscriptionUUID': 'application/vnd.subscriptions.v1+json',
    },
    _a[enums_1.ServicesEnum.ENROLLMENT] = {
        enrollments: 'application/vnd.enrollments.v1+json',
        'enrollments/:enrollmentsUUID': 'application/vnd.enrollments.v1+json',
        academicsessions: 'application/vnd.academicsessions.v1+json',
        'academicsessions/:academicsessionsUUID': 'application/vnd.academicsessions.v1+json',
        'schools/:schoolId/grade-summary': 'application/vnd.school.grading-summary.v1+json',
        'schools/:schoolId/schedule': 'application/vnd.school.schedule.v1+json',
        'schools/:schoolId/students/:studentId/courses/:courseId/schedule': 'application/vnd.school.student-course-schedule.v1+json',
        'schools/:schoolId/average-assignments': 'application/json',
        'events/:eventId': 'application/vnd.school.event.v1+json',
        events: 'application/vnd.school.event.v1+json',
    },
    _a[enums_1.ServicesEnum.OTK_IDENTITY] = {
        'admin/launch': 'application/vnd.launches.v1+json',
        'admin/password': 'application/vnd.password.reset.email.v1+json',
        'users/password/email': 'application/vnd.password.reset.email.v1+json',
        'users/password/token': 'application/vnd.password.reset.token.v1+json',
        login: 'application/json',
        'schools/:schoolUUID/users': 'application/vnd.users.v1+json',
        'admin/schools/:schoolUUID/users': 'application/vnd.users.v1+json',
        launches: 'application/vnd.launches.v1+json',
        'launches/:launchId': 'application/vnd.launches.v1+json',
        'admin/users': 'application/vnd.users.v1+json',
        'shopify/launches/:shopifyid': 'application/json',
    },
    _a[enums_1.ServicesEnum.LMNT] = {
        'launches/:launchUUID': 'application/vnd.launches.plain.v1+json',
    },
    _a);
